/**
 * Download a blob file to the users file system
 * @param {string} filename the name the file should have in the file system
 * @param {Blob} blob
 */
export function downloadBlob(filename: string, blob: Blob) {
  const url = window.URL.createObjectURL(blob);

  downloadURL(filename, url);

  setTimeout(function () {
    window.URL.revokeObjectURL(url);
  }, 10000);
}

/**
 * Download any URL to the users file system
 * @param {string} filename
 * @param {string} dataURL
 */
export function downloadURL(filename: string, dataURL: string) {
  const element = document.createElement("a");
  element.href = dataURL;
  element.download = filename;
  element.style.display = "none";

  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}
